/* eslint-disable react/no-array-index-key */
/* eslint-disable no-lone-blocks */
/* eslint-disable array-callback-return */
/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React, {
    useState, useCallback, useEffect, useRef,
} from 'react';
import moment from 'moment';
import Checkbox from 'react-custom-checkbox';
import * as Icon from 'react-icons/fi';
import { Calendar } from 'react-calendar';
import { distributorService } from '../../../service/distributor.service';
import { createUrl } from '../../../redux/helper/CreateQuery';

function FilterModal({
    filterModal, setFilterModal, Filter, setFilter, filterValue, setfilterValue, handleFilter, handleFetchCreditDebitDetails, selected, setselected, SetSuccessMessage,
}) {
    const dateRef = useRef();
    const transactionTypesRef = useRef();
    const orgCodesRef = useRef();

    const [selectedType, setselectedType] = useState('transaction_type');
    const toggleState = {
        start_date: false,
        end_date: false,
    };
    const [toggle, settoggle] = useState(toggleState);
    
    // Store applied state (what was actually applied via Apply Filter)
    const appliedFilterRef = useRef(null);
    const appliedSelectedRef = useRef(null);
    const filterAppliedRef = useRef(false);
    
    // Parse filterValue to extract applied filters
    const parseFilterValue = useCallback((filterUrl) => {
        const parsedFilter = {
            transaction_type: [],
            date_range: [],
            org_code: [],
        };
        const parsedSelected = {
            start_date: '',
            end_date: '',
        };
        
        if (!filterUrl) {
            return { parsedFilter, parsedSelected };
        }
        
        // Split by & and process each parameter
        const params = filterUrl.split('&').filter(param => param);
        
        params.forEach((param) => {
            if (param.includes('transaction_type=')) {
                const value = param.split('transaction_type=')[1];
                if (value) {
                    parsedFilter.transaction_type = value.split(',').filter(v => v);
                }
            } else if (param.includes('org_code=')) {
                const value = param.split('org_code=')[1];
                if (value) {
                    parsedFilter.org_code = value.split(',').filter(v => v);
                }
            } else if (param.includes('date_range=')) {
                const value = param.split('date_range=')[1];
                if (value) {
                    const dates = decodeURIComponent(value).split(',');
                    if (dates.length === 2) {
                        // Parse DD-MM-YYYY format from filterValue
                        const startDate = moment(dates[0].trim(), 'DD-MM-YYYY');
                        const endDate = moment(dates[1].trim(), 'DD-MM-YYYY');
                        if (startDate.isValid() && endDate.isValid()) {
                            // Store in YYYY-MM-DD format (what selected state expects)
                            parsedSelected.start_date = startDate.format('YYYY-MM-DD');
                            parsedSelected.end_date = endDate.format('YYYY-MM-DD');
                        }
                    }
                }
            }
        });
        
        return { parsedFilter, parsedSelected };
    }, []);
    
    useEffect(() => {
        if (filterModal) {
            // Parse filterValue to get what's actually applied
            const { parsedFilter, parsedSelected } = parseFilterValue(filterValue);
            
            // Populate Filter and selected from the applied filterValue
            setFilter(parsedFilter);
            setselected(parsedSelected);
            
            // Store as applied state (what should persist)
            appliedFilterRef.current = JSON.parse(JSON.stringify(parsedFilter));
            appliedSelectedRef.current = JSON.parse(JSON.stringify(parsedSelected));
            filterAppliedRef.current = false; // Reset flag when modal opens
        }
    }, [filterModal, filterValue, parseFilterValue]);
    
    useEffect(() => {
        if (!filterModal && !filterAppliedRef.current && appliedFilterRef.current && appliedSelectedRef.current) {
            // Modal closed without applying - reset to applied state (what was actually applied)
            setFilter(appliedFilterRef.current);
            setselected(appliedSelectedRef.current);
        }
    }, [filterModal, setFilter, setselected]);

    // Transaction Types pagination state
    const [transactionTypes, setTransactionTypes] = useState([]);
    const [transactionTypesPage, setTransactionTypesPage] = useState(1);
    const [transactionTypesTotalPages, setTransactionTypesTotalPages] = useState(1);
    const [transactionTypesLoading, setTransactionTypesLoading] = useState(false);

    // Org Codes pagination state
    const [orgCodes, setOrgCodes] = useState([]);
    const [orgCodesPage, setOrgCodesPage] = useState(1);
    const [orgCodesTotalPages, setOrgCodesTotalPages] = useState(1);
    const [orgCodesLoading, setOrgCodesLoading] = useState(false);

    const HandleFilter = useCallback((key, val) => {
        const Filtercopy = { ...Filter };
        const idx = Filtercopy[key].indexOf(val);
        if (idx === -1) {
            Filtercopy[key].push(val);
        } else {
            Filtercopy[key].splice(idx, 1);
        }
        Filtercopy[key];
        setFilter(Filtercopy);
        return idx > -1;
    }, [Filter, setFilter]);

    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };

    const handleDate = (val, key) => {
        const state = key === 'start_date' ? 'end_date' : 'start_date';
        if (key === 'start_date') {
            setselected((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        settoggle(toggleState);
        if (key === 'end_date') {
            settoggle(toggleState);
        } else {
            setTimeout(() => {
                handleToggle(state);
            }, 500);
        }
        setselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        if (key === 'end_date') {
            settoggle(toggleState);
        }
    };

    const generateUrl = (val) => {
        let final = '';
        Object.keys(Filter).map((key) => {
            switch (key) {
            case 'transaction_type':
                if (Filter[key].length > 0) {
                    final += `&transaction_type=${createUrl(Filter[key])}`;
                }
                break;
            case 'org_code':
                if (Filter[key].length > 0) {
                    final += `&org_code=${createUrl(Filter[key])}`;
                }
                break;
            default: break;
            }
        });
        if (selected.start_date !== '' && selected.end_date !== '') {
            final += `&date_range=${moment(selected.start_date).format('DD-MM-YYYY')},${moment(selected.end_date).format('DD-MM-YYYY')}`;
        }
        if (val === undefined) {
            handleFilter(final);
            filterAppliedRef.current = true; // Mark that filter was applied
            // Update applied state to current state (so it persists when reopening)
            appliedFilterRef.current = JSON.parse(JSON.stringify(Filter));
            appliedSelectedRef.current = JSON.parse(JSON.stringify(selected));
        }
        setFilterModal(false);
        SetSuccessMessage('Filters applied Successfully!');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
        return final;
    };

    // Check if any filter is currently selected
    const hasSelectedFilters = () => {
        return (
            (Filter.transaction_type && Filter.transaction_type.length > 0) ||
            (Filter.org_code && Filter.org_code.length > 0) ||
            (selected.start_date !== '' && selected.end_date !== '')
        );
    };
    
    // Check if any filter is applied (from filterValue)
    const hasAppliedFilters = () => {
        return filterValue && filterValue.trim() !== '';
    };

    const handleClear = () => {
        const emptyFilter = {
            transaction_type: [],
            date_range: [],
            org_code: [],
        };
        const emptySelected = { start_date: '', end_date: '' };
        setFilter(emptyFilter);
        setselected(emptySelected);
        setfilterValue('');
        handleFetchCreditDebitDetails(1, '', '');
        // Also clear the applied state so it doesn't persist
        appliedFilterRef.current = emptyFilter;
        appliedSelectedRef.current = emptySelected;
        setFilterModal(false);
        SetSuccessMessage('Filters cleared Successfully!');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
    };

    // Fetch Transaction Types
    const fetchTransactionTypes = useCallback((page = 1, append = false) => {
        if (transactionTypesLoading) return;
        setTransactionTypesLoading(true);
        distributorService.GetTransactionTypes(page, 50).then((res) => {
            if (res?.data?.success_status) {
                if (append) {
                    setTransactionTypes((prev) => [...prev, ...(res.data.data || [])]);
                } else {
                    setTransactionTypes(res.data.data || []);
                }
                setTransactionTypesPage(res.data.current_page);
                setTransactionTypesTotalPages(res.data.number_of_pages);
            }
            setTransactionTypesLoading(false);
        });
    }, [transactionTypesLoading]);

    // Fetch Org Codes
    const fetchOrgCodes = useCallback((page = 1, append = false) => {
        if (orgCodesLoading) return;
        setOrgCodesLoading(true);
        distributorService.GetOrganizationCodes(page, 50).then((res) => {
            if (res?.data?.success_status) {
                if (append) {
                    setOrgCodes((prev) => [...prev, ...(res.data.data || [])]);
                } else {
                    setOrgCodes(res.data.data || []);
                }
                setOrgCodesPage(res.data.current_page);
                setOrgCodesTotalPages(res.data.number_of_pages);
            }
            setOrgCodesLoading(false);
        });
    }, [orgCodesLoading]);

    // Handle scroll for infinite scrolling
    const handleTransactionTypesScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollHeight - scrollTop <= clientHeight + 10 && !transactionTypesLoading && transactionTypesPage < transactionTypesTotalPages) {
            fetchTransactionTypes(transactionTypesPage + 1, true);
        }
    };

    const handleOrgCodesScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollHeight - scrollTop <= clientHeight + 10 && !orgCodesLoading && orgCodesPage < orgCodesTotalPages) {
            fetchOrgCodes(orgCodesPage + 1, true);
        }
    };

    // Initial data fetch
    useEffect(() => {
        fetchTransactionTypes(1, false);
        fetchOrgCodes(1, false);
    }, []);

    useEffect(() => {
        const handler = (event) => {
            if (dateRef && dateRef.current && !dateRef.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    start_date: false,
                    end_date: false,
                }));
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef]);

    return (
        <div className={`modal fade fixed top-0 left-0 ${filterModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[570px] mx-auto px-2.5" style={{ margin: 'auto' }}>
                <div
                    className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                >
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            Filter
                        </h5>
                        <button
                            type="button"
                            className="absolute top-4 right-6"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => {
                                setFilterModal(false);
                            }}
                        >
                            <img src="/images/close.svg" alt="icon" className="w-3.5 h-3.5" />
                        </button>
                    </div>
                    <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 w-[40%] h-full" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow w-full text-start mb-4" role="presentation" onClick={() => setselectedType('transaction_type')}>
                                    <a
                                        href="#pills-transactiontype"
                                        className={`nav-link block text-base ${selectedType === 'transaction_type' ? 'active font-bold' : 'font-normal'} text-[#AAA6AF] order relative w-full`}
                                        id="pills-transactiontype-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-transactiontype"
                                        role="tab"
                                        aria-controls="pills-transactiontype"
                                        aria-selected="true"
                                        data-testid="transaction-type"
                                    >
                                        Transaction Type
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full mb-4" role="presentation" onClick={() => setselectedType('org_code')}>
                                    <a
                                        href="#pills-orgcode"
                                        className={`nav-link block text-base ${selectedType === 'org_code' ? 'active font-bold' : 'font-normal'} text-[#AAA6AF] order relative w-full`}
                                        id="pills-orgcode-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-orgcode"
                                        role="tab"
                                        aria-controls="pills-orgcode"
                                        aria-selected="false"
                                        data-testid="org-code"
                                    >
                                        Organization Code
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full mb-4" role="presentation" onClick={() => setselectedType('date_range')}>
                                    <a
                                        href="#pills-daterange"
                                        className={`nav-link block text-base ${selectedType === 'date_range' ? 'active font-bold' : 'font-normal'} text-[#AAA6AF] order relative w-full`}
                                        id="pills-daterange-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-daterange"
                                        role="tab"
                                        aria-controls="pills-daterange"
                                        aria-selected="false"
                                    >
                                        Date Range
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content w-[75%] h-[230px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                                {/* Transaction Type */}
                                <div
                                    ref={transactionTypesRef}
                                    className={`tab-pane fade ${selectedType === 'transaction_type' ? 'show active' : ''} px-3 max-h-[210px] overflow-auto custom-scrollbar`}
                                    id="pills-transactiontype"
                                    role="tabpanel"
                                    aria-labelledby="pills-transactiontype-tab"
                                    onScroll={handleTransactionTypesScroll}
                                >
                                    <div className="relative">
                                        <div className="cursor-pointer">
                                            {transactionTypes && transactionTypes.length > 0 && transactionTypes.map((type, typeIndex) => (
                                                <div className="flex items-center mb-3" key={`type-${typeIndex}`} onClick={() => HandleFilter('transaction_type', type)}>
                                                    <Checkbox
                                                        icon={
                                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.transaction_type?.includes(type) ? '#555259' : ''}` }} />
                                                        }
                                                        name="my-input"
                                                        className="cursor-pointer"
                                                        checked={Filter.transaction_type?.includes(type)}
                                                        borderColor={`${Filter.transaction_type?.includes(type) ? '#B8C5DC' : '#555259'}`}
                                                        style={{ cursor: 'pointer' }}
                                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                        id={type}
                                                    />
                                                    <label data-testid={type} htmlFor={`type-${typeIndex}`} className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">
                                                        {' '}
                                                        {type}
                                                    </label>
                                                </div>
                                            ))}
                                            {transactionTypesLoading && (
                                                <p className="text-sm text-[#808285] text-center">Loading...</p>
                                            )}
                                            {(!transactionTypes || transactionTypes.length === 0) && !transactionTypesLoading && (
                                                <p className="text-sm text-[#808285]">No transaction types available</p>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Organization Code */}
                                <div
                                    ref={orgCodesRef}
                                    className={`tab-pane fade ${selectedType === 'org_code' ? 'show active' : ''} px-3 max-h-[210px] overflow-auto custom-scrollbar`}
                                    id="pills-orgcode"
                                    role="tabpanel"
                                    aria-labelledby="pills-orgcode-tab"
                                    onScroll={handleOrgCodesScroll}
                                >
                                    <div className="relative">
                                        <div className="cursor-pointer">
                                            {orgCodes && orgCodes.length > 0 && orgCodes.map((code, codeIndex) => (
                                                <div className="flex items-center mb-3" key={`code-${codeIndex}`} onClick={() => HandleFilter('org_code', code)}>
                                                    <Checkbox
                                                        icon={
                                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.org_code?.includes(code) ? '#555259' : ''}` }} />
                                                        }
                                                        name="my-input"
                                                        className="cursor-pointer"
                                                        checked={Filter.org_code?.includes(code)}
                                                        borderColor={`${Filter.org_code?.includes(code) ? '#B8C5DC' : '#555259'}`}
                                                        style={{ cursor: 'pointer' }}
                                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                        id={code}
                                                    />
                                                    <label data-testid={code} htmlFor={`code-${codeIndex}`} className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">
                                                        {' '}
                                                        {code}
                                                    </label>
                                                </div>
                                            ))}
                                            {orgCodesLoading && (
                                                <p className="text-sm text-[#808285] text-center">Loading...</p>
                                            )}
                                            {(!orgCodes || orgCodes.length === 0) && !orgCodesLoading && (
                                                <p className="text-sm text-[#808285]">No organization codes available</p>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Date Range */}
                                <div ref={dateRef} className={`tab-pane fade  px-3 ${selectedType === 'date_range' ? 'show active' : ''}`} id="pills-daterange" role="tabpanel" aria-labelledby="pills-daterange-tab">
                                    <div className="relative">
                                        <p className="text-sm text-[#555259] mb-2 text-left">AR Date Range</p>
                                        <div className="flex sm:flex-row flex-col items-center mt-1 -mx-1">
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('start_date')}

                                            >
                                                <label />
                                                <img
                                                    src="/images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('start_date')}

                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-xs9 text-sm29 font-semibold text-[#090406] px-2.5 placeholder:text-xs9 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="From date"
                                                    value={selected.start_date === '' ? '' : moment(selected.start_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.start_date && <Calendar value={moment(selected.start_date).format('YYYY/MM/DD').start_date} onChange={(val) => handleDate(val, 'start_date')} placeholder="Date from" />}
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('end_date')}
                                            >
                                                <label />
                                                <img
                                                    src="/images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('end_date')}
                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-xs9 text-sm29 font-semibold text-[#090406] px-2.5 placeholder:text-xs9 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="To date"
                                                    value={selected.end_date === '' ? '' : moment(selected.end_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.end_date && <Calendar value={moment(selected.end_date).format('YYYY/MM/DD').start_date} onChange={(val) => handleDate(val, 'end_date')} minDate={moment(selected.start_date).toDate()} placeholder="Date to" />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex w-full">
                            <div className="pt-3 flex justify-end w-[40%] mr-4">
                                <button
                                    type="button"
                                    disabled={!hasAppliedFilters()}
                                    className={`w-full sm:h-10 h-9 border-2 rounded-lg text-sm font-semibold ${
                                        hasAppliedFilters()
                                            ? 'border-[#555259] bg-[#FFFFFF] text-[#555259] cursor-pointer'
                                            : 'border-[#E0E0E0] bg-[#F5F5F5] text-[#A0A0A0] cursor-not-allowed opacity-60'
                                    }`}
                                    data-bs-dismiss={hasAppliedFilters() ? 'modal' : ''}
                                    aria-label="Close"
                                    onClick={() => {
                                        if (hasAppliedFilters()) {
                                            handleClear();
                                        }
                                    }}
                                >
                                    Clear Filter
                                </button>
                            </div>
                            <div className="pt-3 flex justify-end w-[70%]">
                                <button
                                    type="button"
                                    disabled={!hasSelectedFilters()}
                                    className={`w-full sm:h-10 h-9 border rounded-lg text-sm font-semibold ${
                                        hasSelectedFilters()
                                            ? 'border-[#555259] bg-[#555259] text-[#FFFFFF] cursor-pointer'
                                            : 'border-[#E0E0E0] bg-[#E0E0E0] text-[#A0A0A0] cursor-not-allowed opacity-60'
                                    }`}
                                    data-bs-dismiss={hasSelectedFilters() ? 'modal' : ''}
                                    aria-label="Close"
                                    data-testid="apply-btn"
                                    onClick={() => {
                                        if (hasSelectedFilters()) {
                                            generateUrl();
                                        }
                                    }}
                                >
                                    Apply Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FilterModal;

